"use client"

import { useQuery } from "@tanstack/react-query"
import { useAuthToken } from "@/hooks/use-auth"

const API_BASE = ""

export interface ActivityItem {
  id: string
  type: "goal" | "persona" | "journey" | "story" | "document"
  title: string
  projectId: string
  projectName: string
  projectEmoji: string
  updatedAt: string
}

async function fetchRecentActivity(token: string | null): Promise<ActivityItem[]> {
  if (!token) return []

  const response = await fetch(`${API_BASE}/api/activity/recent`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    if (response.status === 401) return []
    throw new Error("Failed to fetch activity")
  }

  const data = await response.json()
  return data.data || []
}

export function useRecentActivity() {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["activity", "recent"],
    queryFn: () => fetchRecentActivity(token),
    retry: 1,
  })
}
